import { useEffect, useState, FC } from 'react'
import { Alert } from '@/ui'
import { mtc } from '@/styles'

interface UploadMessageProps {
  content: string
  fadeAfterMS?: number
  success: boolean
}

const UploadMessage: FC<UploadMessageProps> = ({
  content,
  fadeAfterMS,
  success,
}) => {
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    if (fadeAfterMS) {
      const id = setTimeout(() => setVisible(false), fadeAfterMS)
      return () => clearTimeout(id)
    }
    return () => {}
  }, [fadeAfterMS])

  return (
    <div
      aria-live="polite"
      className={mtc(
        'transition-opacity duration-500',
        visible ? 'opacity-100' : 'opacity-0 pointer-events-none'
      )}
    >
      <Alert variant={success ? 'success' : 'error'}>{content}</Alert>
    </div>
  )
}

export { UploadMessage }
